import React from "react";
import { AlertTriangle, Button, Card, CardHeader, CheckCircle, Pencil01 } from "@opendate-app/setlist";

const styles = {
  row: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "14px 24px",
    borderTop: "1px solid var(--sl-border-secondary)",
    fontSize: 14,
  },
  text: { flex: 1, minWidth: 0 },
  label: { fontWeight: 600, color: "var(--sl-text-primary)" },
  summary: {
    color: "var(--sl-text-tertiary)",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
};

const ChecklistCard = ({ checks, onEdit }) => {
  const toFix = checks.filter((check) => !check.ok).length;

  return (
    <Card padding="none" header={<CardHeader title={toFix > 0 ? `Before you publish · ${toFix} to fix` : "Ready to publish"} />}>
      {checks.map((check) => {
        const Icon = check.ok ? CheckCircle : AlertTriangle;

        return (
          <div key={check.label} style={styles.row}>
            <Icon width={20} height={20} color={check.ok ? "var(--sl-fg-success)" : "var(--sl-fg-error)"} />
            <div style={styles.text}>
              <div style={styles.label}>{check.label}</div>
              <div style={styles.summary}>{check.text}</div>
            </div>
            <Button
              variant="tertiary-color"
              size="sm"
              icon={Pencil01}
              aria-label={`Edit ${check.label}`}
              onClick={() => onEdit(check.step)}
            />
          </div>
        );
      })}
    </Card>
  );
};

export default ChecklistCard;
